/* Change this file to get your personal Portfolio */

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation";

// Splash Screen

const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 1800
};

// Illustration

const illustration = {
  animated: true
};

// Greeting Section

const greeting = {
  username: "Himadri Bhattacharya",
  title: "Hi, I'm Himadri",
  subTitle: emoji(
    "Software Developer & AI Engineer 🚀 specializing in Full Stack Development, Generative AI, Multimodal RAG systems, and scalable backend architectures. Currently pursuing M.Tech in CSE at NIT Patna while building production-grade AI applications."
  ),
  resumeLink:
    "YOUR_RESUME_LINK_HERE",
  displayGreeting: true
};

// Social Media Links

const socialMediaLinks = {
  linkedin: "https://www.linkedin.com/in/himadribhattacharya3/",
  github: "https://github.com/himadribh07",
  gmail: "work.himadribhattacharya@gmail.com",
  twitter: "https://twitter.com/slowcheetah07_",
  kaggle: "https://kaggle.com/himadri07",
  display: true
};

// Skills Section

const skillsSection = {
  title: "What I Do",
  subTitle:
    "FULL STACK + AI ENGINEER BUILDING SCALABLE AND INTELLIGENT APPLICATIONS",

  skills: [
    emoji(
      "⚡ Build scalable full-stack applications using React.js, Next.js, Node.js, FastAPI, PostgreSQL, and MongoDB"
    ),

    emoji(
      "⚡ Develop AI-powered systems using LLMs, RAG pipelines, Hugging Face Transformers, Ollama, and Vector Databases"
    ),

    emoji(
      "⚡ Design multimodal AI workflows handling text, images, embeddings, semantic search, and enterprise-scale retrieval systems"
    ),

    emoji(
      "⚡ Build interactive dashboards, REST APIs, real-time applications, and ML-powered products"
    )
  ],

  softwareSkills: [
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "ReactJS",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "NextJS",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "NodeJS",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "FastAPI",
      fontAwesomeClassname: "fas fa-server"
    },
    {
      skillName: "PostgreSQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "TensorFlow",
      fontAwesomeClassname: "fas fa-brain"
    },
    {
      skillName: "PyTorch",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "LLMs",
      fontAwesomeClassname: "fas fa-robot"
    },
    {
      skillName: "RAG",
      fontAwesomeClassname: "fas fa-project-diagram"
    },
    {
      skillName: "Qdrant",
      fontAwesomeClassname: "fas fa-database"
    }
  ],

  display: true
};

// Education Section

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "National Institute of Technology, Patna",
      logo: require("./assets/images/nitp.png"),
      subHeader: "M.Tech in Computer Science and Engineering",
      duration: "2024 - 2026",
      desc: "Focused on Artificial Intelligence, Machine Learning, scalable systems, and modern software engineering.",
      descBullets: [
        "Current CGPA: 8.46",
        "Working on AI/ML, Generative AI, and enterprise-scale backend systems"
      ]
    },

    {
      schoolName: "Narula Institute of Technology, Kolkata",
      logo: require("./assets/images/narula_logo.png"),
      subHeader: "B.Tech in Electronics & Communication Engineering",
      duration: "2018 - 2022",
      descBullets: [
        "Graduated with 9.05 CGPA",
        "Built strong fundamentals in programming, algorithms, and system design"
      ]
    }
  ]
};

// Tech Stack

const techStack = {
  viewSkillBars: true,

  experience: [
    {
      Stack: "Frontend / Full Stack Development",
      progressPercentage: "88%"
    },
    {
      Stack: "Backend & APIs",
      progressPercentage: "85%"
    },
    {
      Stack: "AI / Machine Learning / GenAI",
      progressPercentage: "82%"
    },
    {
      Stack: "Databases & Vector Search",
      progressPercentage: "78%"
    }
  ],

  displayCodersrank: false
};

// Work Experience

const workExperiences = {
  display: true,

  experience: [
    {
      role: "Software Developer Intern",
      company: "Bosch Global Software Technologies",
      companylogo: require("./assets/images/bosch.png"),
      date: "Sept 2025 – Present",

      desc:
        "Working on production-grade multimodal Retrieval-Augmented Generation (RAG) systems and enterprise AI pipelines.",

      descBullets: [
        "Architected and deployed multimodal RAG systems for processing text, tables, and images",
        "Integrated Qdrant vector database for scalable semantic search and embedding retrieval",
        "Built hierarchical retrieval workflows improving search precision and response quality",
        "Worked with Qwen2.5 via Ollama for model benchmarking, evaluation, and response validation"
      ]
    },

    {
      role: "Software Developer",
      company: "Persistent Systems",
      companylogo: require("./assets/images/persistent_logo.png"),
      date: "Jun 2022 – Mar 2023",

      desc:
        "Worked on scalable frontend systems, performance optimization, and enterprise web applications.",

      descBullets: [
        "Developed scalable React.js modules and SQL-driven applications",
        "Improved frontend performance and reduced page load time by 15%",
        "Collaborated with QA, DevOps, and product teams to deliver major milestones"
      ]
    },

    {
      role: "Software Developer Intern",
      company: "Persistent Systems",
      companylogo: require("./assets/images/persistent_logo.png"),
      date: "Jan 2022 – Jun 2022",

      descBullets: [
        "Modernized legacy React modules and built reusable UI components",
        "Reduced code duplication and improved build efficiency significantly",
        "Worked in Agile teams using Scrum and Kanban methodologies"
      ]
    }
  ]
};

// Open Source

const openSource = {
  showGithubProfile: "true",
  display: true
};

// Projects Section

const bigProjects = {
  title: emoji("Projects 🚀"),

  projects: [
    {
      image: require("./assets/images/bosch.png"),
      projectName: "AI News Podcast App",

      projectDesc:
        "AI-powered full-stack podcast platform using Google Gemini API, FastAPI, React.js, and gTTS to generate and stream category-based news podcasts.",

      footerLink: [
        {
          name: "GitHub",
          url: "YOUR_GITHUB_LINK"
        }
      ]
    },

    {
      image: require("./assets/images/bosch.png"),
      projectName: "YouTube Comment Sentiment Analysis",

      projectDesc:
        "Built an NLP-based sentiment analysis application using Hugging Face Transformers, PyTorch, Streamlit, and YouTube Data API.",

      footerLink: [
        {
          name: "GitHub",
          url: "YOUR_GITHUB_LINK"
        }
      ]
    }
  ],

  display: true
};

// Achievements Section

const achievementSection = {
  title: emoji("Achievements & Certifications 🏆"),

  subtitle:
    "Certifications, achievements, and technical milestones.",

  achievementsCards: [
    {
      title: "Microsoft Azure Fundamentals (AZ-900)",

      subtitle:
        "Certified in cloud fundamentals, Azure services, security, pricing, and cloud architecture concepts.",

      image: require("./assets/images/azure.png"),

      imageAlt: "Azure Logo",

      footerLink: [
        {
          name: "Certification",
          url: "YOUR_CERTIFICATE_LINK"
        }
      ]
    }
  ],

  display: true
};

// Contact Info

const contactInfo = {
  title: emoji("Contact Me ☎️"),

  subtitle:
    "Interested in collaborating, internships, AI projects, or software engineering opportunities? Let's connect.",

  email_address: "work.himadribhattacharya@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "slowcheetah07_",
  display: false
};

// Hireable

const isHireable = true;

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  contactInfo,
  twitterDetails,
  isHireable
};